import { getWatchlistSettings } from '../components/watchlist/WatchlistHelpers';
import { get } from 'lodash';

export const SET_FILE_TYPE = 'WATCHLIST/SET_FILE_TYPE';
export const SET_TYPE = 'WATCHLIST/SET_TYPE';
export const SET_UNIVERSE = 'WATCHLIST/SET_UNIVERSE';
export const SET_METRIC = 'WATCHLIST/SET_METRIC';
export const SET_SELECTED_WATCHLIST = 'WATCHLIST/SET_SELECTED_WATCHLIST';
export const SET_IS_FILTER_ACTIVE = 'WATCHLIST/SET_IS_FILTER_ACTIVE';
export const SET_COMPLETE_COMPANIES_DATA = 'WATCHLIST/SET_COMPLETE_COMPANIES_DATA';
export const SET_COMPLETE_COMPANIES_GLOBAL_DATA = 'WATCHLIST/SET_COMPLETE_COMPANIES_GLOBAL_DATA';
export const SET_NOTIFICATION_DATA = 'WATCHLIST/SET_NOTIFICATION_DATA';
export const SET_SELECTED_FILTER = 'WATCHLIST/SET_SELECTED_FILTER';
export const SET_IS_ACTIVE_COMPANIES = 'WATCHLIST/SET_IS_ACTIVE_COMPANIES';
export const SET_WATCHLIST_CATEGORIES = 'WATCHLIST/SET_WATCHLIST_CATEGORIES';
export const SET_SELECTED_CATEGORY_ID = 'WATCHLIST/SET_SELECTED_CATEGORY_ID';
export const SET_SELECTED_EXCHANGE = 'WATCHLIST/SET_SELECTED_EXCHANGE';
export const SET_WATCHLIST_DIALOG = 'WATCHLIST/SET_WATCHLIST_DIALOG';
export const SET_SHOW_SOCIAL_COMPANIES = 'WATCHLIST/SET_SHOW_SOCIAL_COMPANIES';

export const setShowSocialCompanies = showSocialCompanies => ({
  type: SET_SHOW_SOCIAL_COMPANIES,
  showSocialCompanies,
});
export const setIsActiveCompanies = isActiveCompanies => ({
  type: SET_IS_ACTIVE_COMPANIES,
  isActiveCompanies,
});
export const setSelectedFilter = selectedFilter => ({
  type: SET_SELECTED_FILTER,
  selectedFilter,
});
export const setWatchlistType = watchlistType => ({
  type: SET_TYPE,
  watchlistType,
});
export const setWatchlistFileType = fileType => ({
  type: SET_FILE_TYPE,
  fileType,
});
export const setWatchlistUniverse = universe => ({
  type: SET_UNIVERSE,
  universe,
});
export const setWatchlistMetric = metric => ({
  type: SET_METRIC,
  metric,
});
export const setSelectedWatchlist = selectedItem => ({
  type: SET_SELECTED_WATCHLIST,
  selectedItem,
});
export const setIsFilterActive = isFilterActive => ({
  type: SET_IS_FILTER_ACTIVE,
  isFilterActive,
});
export const setCompleteCompaniesData = completeCompaniesData => ({
  type: SET_COMPLETE_COMPANIES_DATA,
  completeCompaniesData,
});
export const setCompleteGlobalCompaniesData = completeCompaniesDataGlobal => ({
  type: SET_COMPLETE_COMPANIES_GLOBAL_DATA,
  completeCompaniesDataGlobal,
});
export const setNotificationData = notifications => ({
  type: SET_NOTIFICATION_DATA,
  notifications,
});
export const setWatchlistCategories = watchlistCategories => ({
  type: SET_WATCHLIST_CATEGORIES,
  watchlistCategories,
});
export const setSelectedCategoryID = selectedCategoryID => ({
  type: SET_SELECTED_CATEGORY_ID,
  selectedCategoryID,
});
export const setSelectedExchange = selectedExchange => ({
  type: SET_SELECTED_EXCHANGE,
  selectedExchange,
});
export const setWatchlistDialog = watchlistDialog => ({
  type: SET_WATCHLIST_DIALOG,
  watchlistDialog,
});

const getDefaultState = () => {
  const watchlistSetting = getWatchlistSettings();
  return {
    isActiveCompanies: true,
    selectedType: null,
    selectedFileType: get(watchlistSetting, 'selectedFileType', 'all'),
    selectedUniverse: get(watchlistSetting, 'selectedUniverse', 'all'),
    selectedMetric: get(watchlistSetting, 'selectedMetric', 'totdoc'),
    selectedCategoryID: get(watchlistSetting, 'selectedCategoryID', null),
    selectedExchange: get(watchlistSetting, 'selectedExchange', 'all'),
    selectedItem: null,
    isFilterActive: false,
    completeCompaniesData: [],
    completeCompaniesDataGlobal: [],
    notifications: [],
    selectedFilter: null,
    watchlistCategories: [],
    watchlistDialog: false,
    showSocialCompanies: false,
  };
};

export default function reducer(
  state = {
    ...getDefaultState(),
  },
  action
) {
  switch (action.type) {
    case SET_IS_ACTIVE_COMPANIES:
      return { ...state, isActiveCompanies: action.isActiveCompanies };
    case SET_FILE_TYPE:
      return { ...state, selectedFileType: action.fileType };
    case SET_TYPE:
      return {
        ...state,
        selectedType: action.watchlistType,
        selectedMetric: action.watchlistType === 'global' ? 'totdoc' : state.selectedMetric,
      };
    case SET_UNIVERSE:
      return { ...state, selectedUniverse: action.universe };
    case SET_METRIC:
      return { ...state, selectedMetric: action.metric };
    case SET_SELECTED_WATCHLIST:
      return { ...state, selectedItem: action.selectedItem };
    case SET_IS_FILTER_ACTIVE:
      return { ...state, isFilterActive: action.isFilterActive };
    case SET_COMPLETE_COMPANIES_DATA:
      return { ...state, completeCompaniesData: action.completeCompaniesData };
    case SET_COMPLETE_COMPANIES_GLOBAL_DATA:
      return { ...state, completeCompaniesDataGlobal: action.completeCompaniesDataGlobal };
    case SET_NOTIFICATION_DATA:
      return { ...state, notifications: action.notifications };
    case SET_SELECTED_FILTER:
      return { ...state, selectedFilter: action.selectedFilter };
    case SET_WATCHLIST_CATEGORIES:
      return { ...state, watchlistCategories: action.watchlistCategories };
    case SET_SELECTED_CATEGORY_ID:
      return { ...state, selectedCategoryID: action.selectedCategoryID };
    case SET_SELECTED_EXCHANGE:
      return { ...state, selectedExchange: action.selectedExchange };
    case SET_WATCHLIST_DIALOG:
      return { ...state, watchlistDialog: action.watchlistDialog };
    case SET_SHOW_SOCIAL_COMPANIES:
      return { ...state, showSocialCompanies: action.showSocialCompanies };
    default:
      break;
  }
  return state;
}
